import {
	createApp
} from 'vue'
import 'ant-design-vue/dist/antd.less';
import App from './App.vue'
import router from './router'
import store from './store'
import Storage from 'vue-lsp'

import { VueClipboard } from '@soerenmartius/vue3-clipboard'
//<button v-clipboard="value">Copy</button> 复制
import vue3TreeOrg from 'vue3-tree-org'; // 组织架构图
import 'vue3-tree-org/lib/vue3-tree-org.css'; // 组织架构图样式

const app = createApp(App)
	.use(store)
	//.use(store1)
	.use(router)
	.use(VueClipboard)
	.use(vue3TreeOrg)
	.use(Storage, {
		namespace: 'vuejs__',
		name: 'ls',
		storage: 'local',
	})
	.mount('#app')

